module.exports = __webpack_public_path__ + "static/media/goal.1790a2dd.png";